import { HolidayMode } from '@theme/palettes/getPalette';
import { BindConfetti } from './BindConfetti';
import { CoinShower } from './CoinShower';
import { FloatingParticles } from './FloatingParticles';
import { SleighFlyover } from './SleighFlyover';
import { TurkeyTrot } from './TurkeyTrot';
import { useActiveHoliday } from './useActiveHoliday';

const HEART_COLORS = ['#e84a6f', '#ff8fab', '#c9184a'];
const CLOVER_COLORS = ['#2e9d4f', '#3fb862', '#23803f'];

/** Page-level holiday animations. Mounted once in App so they survive route changes. */
export const HolidayEffects = () => {
  const holiday = useActiveHoliday();

  switch (holiday) {
    case HolidayMode.Thanksgiving:
      return <TurkeyTrot />;
    case HolidayMode.Christmas:
      return <SleighFlyover />;
    case HolidayMode.NewYear:
      return <BindConfetti />;
    case HolidayMode.Valentines:
      return <FloatingParticles shape='heart' direction='up' colors={HEART_COLORS} />;
    case HolidayMode.StPatricks:
      return (
        <>
          <FloatingParticles shape='clover' direction='down' colors={CLOVER_COLORS} />
          <CoinShower />
        </>
      );
    default:
      return null;
  }
};
